import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastMessage {
  text: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  duration?: number; // ms
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _messages = new BehaviorSubject<ToastMessage[]>([]);
  messages$ = this._messages.asObservable();

  show(message: ToastMessage) {
    console.log('[ToastService] show()', message);
    const current = this._messages.value;
    this._messages.next([...current, message]);

    setTimeout(() => this.remove(message), message.duration ?? 3000);
  }

  private remove(message: ToastMessage) {
    this._messages.next(this._messages.value.filter(m => m !== message));
  }
}
